export default __webpack_public_path__ + "static/media/vuesax-linear-location.0c31f45b.svg";